import { MenuT } from 'types/frontend/Menu';
import { MyInfoT } from 'types/shared/core/User';

// 나중에 다국어 함수로 대체
const t = (str: string) => str;

const settingMenuRootPath = '/teacherSide/setting';
const isBillSettingVisible = (myInfo: MyInfoT | null) =>
  !!myInfo?.teacherInfo?.teacher.isFinancialManager;
const isFeatureStatusMenuVisible = (myInfo: MyInfoT | null) => {
  const academyId = myInfo?.teacherInfo?.academy.id;
  if (!academyId) return false;

  const isDevelopment =
    typeof window !== 'undefined' && window.location.host.includes('-local');
  return (isDevelopment && academyId === 1) || (!isDevelopment && academyId === 12);
};

const settingMenu: MenuT = [
  {
    title: t('원 기본 설정'),
    items: [
      {
        title: t('원 정보'),
        path: '/teacherSide/setting/academyInfo',
      },
      {
        title: t('요금제/결제정보'),
        path: `${settingMenuRootPath}/billingPlan`,
      },
      {
        title: t('기능 사용 현황'),
        path: `${settingMenuRootPath}/billingPlan/features`,
        visibilityCriteria: isFeatureStatusMenuVisible,
      },
    ],
  },
  {
    title: t('서비스 설정'),
    items: [
      {
        title: t('학원관리 설정'),
        path: `${settingMenuRootPath}/academyManagement`,
      },
      {
        title: t('학원비 설정'),
        path: `${settingMenuRootPath}/billSetting`,
        visibilityCriteria: isBillSettingVisible,
      },
      {
        title: t('출결 설정'),
        path: `${settingMenuRootPath}/attendance`,
      },
      {
        title: t('글/댓글 설정'),
        path: `${settingMenuRootPath}/post`,
      },
      {
        title: t('숙제 설정'),
        path: `${settingMenuRootPath}/homework`,
      },
      {
        title: t('상담톡 설정'),
        path: `${settingMenuRootPath}/chat`,
      },
      {
        title: t('교재 설정'),
        path: `${settingMenuRootPath}/textbook`,
        accessablePositions: ['director', 'assistantDirector'],
      },
      {
        title: t('문자/알림톡 설정'),
        path: `${settingMenuRootPath}/message`,
      },
      {
        title: t('컨텐츠 포인트 설정'),
        path: `${settingMenuRootPath}/contentPoint`,
      },
    ],
  },
];

export { settingMenu };
